<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="inconsistências"
    >
        <rkm-table
            :fields="fields"
            :items="items"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    created() {
        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.ria.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        fields: [
            {key: 'resposta', label: 'Resposta', sortable: true},
        ],
        items: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(documentoImunologicoRotinaId) {
            this.$refs.RkmModal.show()
            this.reset()
            this.load(documentoImunologicoRotinaId)
        },
        load(documentoImunologicoRotinaId) {
            this.setLoading()

            this.repositories.gerenciamentoEnvio.inconsistencias(documentoImunologicoRotinaId)
                .then((response) => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.items = []
        },
    },
    mixins: [error, repository],
}
</script>